<div class="card-actions-selector" [ngClass]="{ 'card-actions-selector__selected  bottom-line': isOpened }">
    <div id="{{ menuButtonId }}" role="button" class="card-actions-button" tabindex="0" (click)="openClicked($event)"
        (keydown.enter)="openClicked($event)" (keydown.space)="openClicked($event)" (keydown.tab)="closeMenu()"
        aria-haspopup="true" attr.aria-controls="{{ menuId }}" [attr.aria-expanded]="isOpened || null" #menuButton>
        <span class="card-actions-selector__info-icon icon icon-actions"></span>
        <span class="card-actions-selector__info-link-text">
            <span>{{ 'RELATED_CARD_ACTIONS' | translate }}</span>
            <span class="icon icon-arrow-dropdown"></span>
            <span class="icon icon-up-chevron"></span>
        </span>
    </div>

    <div class="card-actions-selector__content" [ngClass]="{ dropdown__display: isOpened }">
        <ul id="{{ menuId }}" class="dropdown__actions" role="menu" tabindex="-1"
            attr.aria-labelledby="{{ menuButtonId }}">
            <li *ngFor="let action of actions; index as i" role="none">
                <a class="selected" role="menuitem" (click)="actionClicked(action)" tabindex="-1"
                    (keydown)="onMenuItemKeyDown($event, action)" #menuItem>
                    {{ action | translate }}
                </a>
            </li>
        </ul>
    </div>
</div>
